import Box from '@/common/components/Box'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ListHeader from '@/common/components/ListHeader'
import { DatePickerWithRange } from '@/common/components/ui/dateRangePicker'
import { useFilterDate } from '@/common/hooks/useFilterDate'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { ChartDataTransformer } from '@/common/services/chartDataTransformer'
import { Mapper } from '@/common/services/mapper'
import { ChartData } from '@/common/types/chart.type'
import { useDashboardData } from '@/features/dashboard/hooks/useDashboardData'
import { ChartSection } from '@/features/dashboard/pages/components/ChartSection'
import { PieChartIcon } from 'lucide-react'

const Show = () => {
  const { filterParams, setFilterParams } = useFilterParams()
  const { date, formattedDate } = useFilterDate(filterParams)

  const {
    data: dashboardData,
    isLoading,
    error: companyBillsError = {} as any,
    refetch: refetchDashboard,
  } = useDashboardData<ChartData[]>({
    filters: {
      startDate: formattedDate.from,
      endDate: formattedDate.to,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: ChartDataTransformer.chartTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-6 max-h-[calc(100vh-64px)] overflow-y-auto">
      <ListHeader Icon={<PieChartIcon className="size-10" strokeWidth={1} />} title="Dashboard" />

      <ErrorMessageWrapper
        className="h-[calc(100vh-192px)]"
        statusCode={companyBillsError?.status}
        refetchFunction={refetchDashboard}
      >
        <div className="flex flex-col gap-6">
          <div className="flex">
            <DatePickerWithRange date={date} setDate={(date) => setFilterParams((params) => ({ ...params, date }))} />
          </div>

          {isLoading ? (
            <Box>Carregando...</Box>
          ) : (
            <div className="grid grid-cols-12 gap-6">
              {dashboardData?.map((chartData) => (
                <ChartSection key={chartData.title} chartData={chartData} />
              ))}
            </div>
          )}
        </div>
      </ErrorMessageWrapper>
    </div>
  )
}

export default Show
